const META_ID = process.env.REACT_APP_META_PIXEL_ID;
const GADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const GADS_LEAD_LABEL = process.env.REACT_APP_GOOGLE_ADS_LEAD_LABEL;

let loaded = false;

export function initPixels() {
  if (loaded || typeof window === "undefined") return;
  loaded = true;
  if (META_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", META_ID); window.fbq("track", "PageView");
  }
  if (GADS_ID) {
    const s = document.createElement("script"); s.async = true; s.src = `https://www.googletagmanager.com/gtag/js?id=${GADS_ID}`; document.head.appendChild(s);
    window.dataLayer = window.dataLayer || []; window.gtag = function () { window.dataLayer.push(arguments); }; window.gtag("js", new Date()); window.gtag("config", GADS_ID);
  }
}

export function trackLead({ kind, lead_id, source = "form" }) {
  const payload = { content_name: `${kind}_lead`, content_category: source, lead_id };
  window.__velocity_last_lead_event = { kind, lead_id, source, at: Date.now() };
  if (window.fbq) window.fbq("track", "Lead", payload, { eventID: lead_id });
  if (window.gtag) {
    window.gtag("event", "generate_lead", { lead_kind: kind, lead_source: source, transaction_id: lead_id });
    if (GADS_ID && GADS_LEAD_LABEL) window.gtag("event", "conversion", { send_to: `${GADS_ID}/${GADS_LEAD_LABEL}`, transaction_id: lead_id });
  }
}

export const pixelsConfigured = { meta: !!META_ID, google: !!GADS_ID };
